<div class="contents-info" [ngClass]="type">
  <p class="contents-placeholder" *ngIf="type === 'book' && placeholder">
    {{ placeholder | translate }}
  </p>

  <img *ngIf="image" class="contents-image" src="{{ image }}" />
  <div class="contents-text" *ngIf="title || author">
    <strong *ngIf="title" class="contents-title">
      {{ title }}
    </strong>
    <p *ngIf="author" class="contents-author text-secondary">
      {{ author }}
    </p>
  </div>
</div>
